module.exports = __webpack_public_path__ + "img/member-card.6cff7636.png";